<template>
  <div class="orderRenewal-personal-add">
    <div>
      <OrderRenewalStep
        :fixedStepIndex="originStep"
        :currentStepIndex="currentStep"
        :steps="stepList"
      />
    </div>
    <keep-alive>
      <component
        :is="currentComponent"
        class="component"
        orderType="personal"
        :orderDataList="orderDataList"
        :renewalOrderDataList="renewalOrderDataList"
        :prevBtnLoading="checkingBack"
        @completeOrderSelect="handleCompleteOrderSelect"
        @completeRentInfoFillin="handleRentInfoFillin"
        @previousStep="handlePreviousStep"
      />
    </keep-alive>
  </div>
</template>
<script>
import { getRentOrderDetail } from '@/api/domain/underLease'
import { checkOrderBack, getRentOrderConfig } from '@/api/purchaseAndSaleAPI'
import OrderConfirm from './components/orderConfirm/index.vue'
import OrderRenewalStep from './components/orderRenewalStep/index.vue'
import OriginOrderInfo from './components/originOrderInfo/index.vue'
import Personal from './components/rentInfo/Personal.vue'
import { PERSONAL_ADD_STEPS } from './config'

export default {
  data() {
    return {
      originStep: 0,
      currentStep: 0,
      stepList: PERSONAL_ADD_STEPS,
      orderDataList: [],
      renewalOrderDataList: [],
      /**
       * 注意：这里有两种参数格式，分别是：
       * 1、从订单续约列表点击订单确认：?query={oldOrderId: '原订单ID', orderId: '当前订单ID'}
       * 2、从租赁中订单列表点击订单续约：?orderId=原订单ID
       */
      queries: this.$route.query.query ? JSON.parse(decodeURIComponent(this.$route.query.query || '{}')) : this.$route.query,
      // 待修改的订单信息
      prevOrderConfig: {},
      // 返回上一步校验标识
      checkingBack: false,
    }
  },
  computed: {
    currentComponent() {
      if (this.currentStep === 0) {
        return 'OriginOrderInfo'
      }
      if (this.currentStep === 1) {
        return 'Personal'
      }
      if (this.currentStep === 2) {
        return 'OrderConfirm'
      }
      return ''
    },
  },
  provide() {
    return {
      getOrderConfigInfo: () => this.prevOrderConfig,
    }
  },
  methods: {
    async init() {
      const { orderId, step } = this.queries
      if (orderId) {
        if (parseInt(step, 10) === 1) {
          const res = await getRentOrderDetail({ orderId })
          const { data } = res || {}
          if (data) {
            const orderDataList = [data]
            this.handleCompleteOrderSelect(orderDataList)
          }
        } else {
          this.originStep = 2
          this.currentStep = 2
        }
      }
    },
    // 完成原订单选择的回调
    handleCompleteOrderSelect(data) {
      this.orderDataList = data
      this.originStep = 1
      this.currentStep = 1
    },
    // 完成租赁信息填写的回调
    handleRentInfoFillin(data) {
      this.renewalOrderDataList = data
      this.originStep = 2
      this.currentStep = 2
    },
    // 从订单确认页面返回租赁信息
    async handlePreviousStep(orderId) {
      this.checkingBack = true
      // 后端接口逻辑：满足以下任一条件，则不可返回上一步
      // 1、合同签约中
      // 2、合同签约失败
      // 3、代扣签约中
      // 4、代扣签约失败
      const backAvailableRes = await checkOrderBack({ orderId })
      if (backAvailableRes.code !== 1) {
        this.checkingBack = false
        return
      }
      // 获取订单配置信息
      const orderConfigRes = await getRentOrderConfig({ orderId })
      if (orderConfigRes.code === 1) {
        this.prevOrderConfig = orderConfigRes.data
      } else {
        this.checkingBack = false
        return
      }
      // 获取原始订单信息
      const originOrderRes = await getRentOrderDetail({
        orderId: orderConfigRes.data.relatedOrderId,
      })
      if (originOrderRes.code === 1) {
        this.orderDataList = [originOrderRes.data]
        this.init()
        this.originStep--
        this.currentStep--
      }
      this.checkingBack = false
    },
  },
  created() {
    this.init()
  },
  components: {
    OriginOrderInfo,
    OrderRenewalStep,
    Personal,
    OrderConfirm,
  },
}
</script>
<style lang="scss" scoped>
.orderRenewal-personal-add {
  margin-top: 20px;
  margin-right: 16px;
  .component {
    margin-top: 40px;
  }
}
</style>
